import { render, staticRenderFns } from "./OttHeaderWidget.vue?vue&type=template&id=13de5e66"
import script from "./OttHeaderWidget.vue?vue&type=script&lang=js"
export * from "./OttHeaderWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports